import React, { PropTypes, Component } from 'react';
import styled from 'styled-components';
import { NitroText } from 'nitro-components';

const Plate = styled.div`
border: 1px solid #000000;
border-radius: 4px;
background-color: ${props => (props.active ? '#FFE600' : props.theme.color.white)};
text-align:center;
height: 27px;
width: 80px;
margin: 0 auto;
line-height: 25px;
opacity: ${props => (props.active ? 1 : 0.4)};
transition: box-shadow .3s;
box-shadow: ${props => (props.active ? '0px 2px 2px rgba(0,0,0,0.2)' : 'none')};

&:hover {
	${props => !props.active && `
		box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
	`}
}
`;

const Container = styled.div`
padding-bottom:12px;
display: block;
`;

const RegoPlate = props => (
	<Container>
		<Plate active={props.active}>
			<NitroText size={12} bold variant="black">{props.value}</NitroText>
		</Plate>
	</Container>
);

RegoPlate.propTypes = {
	value: PropTypes.string,
	active: PropTypes.bool
};

RegoPlate.defaultProps = {
	// defaultProp: ''
};

export default RegoPlate;



// WEBPACK FOOTER //
// ./src/components/vehicle/RegoPlate.js